/* eslint-disable react/no-danger */
import Text from '@zenbusiness/common-components/Text';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';

import { EducationDOMPurify } from '../../utils/DOMPurify';

const StyledText = styled(Text)(({ theme }) => ({

  '& a': {
    color: theme.palette.btnWisdomSecondaryDefault.main
  },
  '& b': {
    color: theme.palette.focus90.main
  }
}));

const FormattedText = ({
  dirtyText = '', ...props
}) => {
  const sanitizedText = EducationDOMPurify.sanitize(dirtyText, {
    USE_PROFILES: { html: true },
    ALLOWED_TAGS: ['i', 'a', 'sup', 'sub', 'b', 'p', 'em']
  });

  // It is ok and safe to use 'dangerouslySetInnerHTML' here since we own
  // the data source and we are sanitizing the incoming html allowing just the tags
  // we need and want.
  // ** DO NOT USE THIS COMPONENT IN ANY KIND OF USER INPUT **
  return (
    <StyledText {...props} dangerouslySetInnerHTML={{ __html: sanitizedText }} />
  );
};

FormattedText.propTypes = {
  dirtyText: PropTypes.string
};

export { FormattedText };
